// extracted by mini-css-extract-plugin
export default {"root":"ClientIdQrModal_root__H0yta","panel":"ClientIdQrModal_panel__AD1JS"};